import { render, staticRenderFns } from "./AppNavigator.vue?vue&type=template&id=a21c0724&scoped=true&"
import script from "./AppNavigator.vue?vue&type=script&lang=js&"
export * from "./AppNavigator.vue?vue&type=script&lang=js&"
import style0 from "./AppNavigator.vue?vue&type=style&index=0&id=a21c0724&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a21c0724",
  null
  
)

export default component.exports